import axios from ".";
export const getObjectiveTitle = (params: any) => {
  return axios({
    method: "GET",
    url: `/objective/search`,
    params,
  });
};
/** Search initiatives. */
export const getInitiativeTitle = (params: any) => {
  return axios({
    method: "GET",
    url: `/initiative/search`,
    params,
  });
};
/** Search milestones by search text. */
export const getMilestoneTitle = (params: any) => {
  return axios({
    method: "GET",
    url: `/milestone/search`,
    params: params,
  });
};
/** Search key results. */
export const getKeyResultTitle = (params?: any) => {
  return axios({
    method: "GET",
    url: `/key-results/search`,
    params,
  });
};
